import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HandIcon } from 'lucide-react';
import { Button } from '../components/ui/button';

export const WelcomeScreen = ({ onStart }) => {
  const navigate = useNavigate();

  const handleStart = () => {
    onStart();
    navigate('/product');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-background via-muted/20 to-background flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="text-center max-w-2xl"
      >
        {/* Brand Logo */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mb-12 flex justify-center"
        >
          <img 
            src="https://customer-assets.emergentagent.com/job_pekika-terminal/artifacts/lvarjo7x_Kopie%20van%20pekika.png"
            alt="Pekika Point"
            className="w-64 h-auto md:w-80"
          />
        </motion.div>

        {/* Tap to Start Animation */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="mt-20"
        >
          <Button
            onClick={handleStart}
            size="lg"
            data-testid="start-order-btn"
            className="btn-kiosk bg-gradient-to-r from-primary via-primary-glow to-secondary hover:from-primary-glow hover:to-primary text-primary-foreground px-12 py-8 rounded-full text-xl font-semibold shadow-[0_0_50px_hsl(45_100%_51%/0.4)] hover:shadow-[0_0_70px_hsl(45_100%_60%/0.6)] transition-all duration-300"
          >
            Start je bestelling
          </Button>
          
          {/* Animated hand icon */}
          <motion.div
            animate={{ 
              y: [0, -10, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{ 
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }}
            className="mt-8 flex justify-center"
          >
            <div className="w-16 h-16 rounded-full bg-muted/30 flex items-center justify-center">
              <HandIcon className="w-8 h-8 text-primary" strokeWidth={2} />
            </div>
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default WelcomeScreen;